import consultations from '@/store/mods/clinique/consultations'

export default {
    data() {
        return {
            medecins: [], medecin_id: null, medecin_nom_initial: '',
            medecins_loading: false, medecins_error: '', medecins_request: 0,
            medecin_verifying: false, medecin_paiement: null,
            auto_attribution: null, medecin_reservation: null, medecin_reservation_paiement: null,
            proposition_visible: false, proposition_medecin: null, proposition_busy: false,
            proposition_error: '', medecin_contexte: '', medecin_generation: 0,
            ajout_medecin_visible: false, ajout_medecins: [], ajout_medecin_id: null,
            ajout_medecins_loading: false, ajout_medecin_busy: false, ajout_medecin_error: '',
            consultation_generee_id: null, reattribution_busy: false, reattribution_a_jour: false,
            reattribution_message: '',
            // RDV-010 : présélection du médecin du rendez-vous, une seule fois, au premier chargement réussi de la liste éligible ;
            // note affichée quand ce médecin n'est pas attribuable à la spécialité
            preselection_rdv: false, note_medecin_rdv: ''
        }
    },
    computed: {
        // RDV-010 : bon ouvert par « Générer le bon » de l'agenda — contexte du rendez-vous (propriété « rendez_vous » du
        // bon, passée par la route), retenu seulement pour ce patient et cette spécialité
        rdv_bon() {
            const rdv = this.rendez_vous
            if (!rdv || typeof rdv !== 'object' || !(Number(rdv.id) > 0)) return null
            if (!this.chosen_patient || Number(rdv.patient_id) !== Number(this.chosen_patient.id)) return null
            if (!this.selected_type_consultation || Number(rdv.type_consultation_id) !== Number(this.selected_type_consultation.consult_id)) return null
            return rdv
        },
        rdv_medecin() {
            const rdv = this.rdv_bon
            return rdv && Number(rdv.medecin_id) > 0 ? { id: Number(rdv.medecin_id), nom: rdv.medecin_nom || '' } : null
        },
        // Médecin non attribuable, ou autre médecin choisi : la Clinique n'honorera pas ce rendez-vous au paiement
        avertissement_medecin_rdv() {
            const medecin = this.rdv_medecin
            if (!medecin || this.is_printable || this.bon_is_printable) return ''
            if (this.note_medecin_rdv) return this.note_medecin_rdv
            if (this.medecin_id && Number(this.medecin_id) !== medecin.id) {
                return 'Médecin différent de celui du rendez-vous : le rendez-vous ne sera pas marqué honoré automatiquement ; marquez-le depuis l’agenda.'
            }
            return ''
        },
        canAttributeMedecin() {
            return ['ROLE_ACCUEIL', 'ROLE_CAISSIERE', 'ROLE_CAISSIERE_INTERMITENT', 'ROLE_ADMINISTRATEUR'].includes(this.activeRole.nom)
        },
        medecinChoisi() {
            return this.medecins.find(item => Number(item.id) === Number(this.medecin_id)) || null
        },
        medecinNom() {
            if (!this.medecin_id) return ''
            return this.medecinChoisi ? this.medecinChoisi.nom : this.medecin_nom_initial
        },
        medecinInvalide() {
            return !!this.medecin_id && !this.medecinChoisi
        },
        peutReattribuerBon() {
            return !!this.consultation_generee_id && this.is_printable &&
                ['ROLE_ACCUEIL', 'ROLE_CAISSIERE', 'ROLE_CAISSIERE_INTERMITENT'].includes(this.activeRole.nom)
        },
        medecinBonModifie() {
            return this.is_printable && Number(this.medecin_id) !== Number(this.medecin_paiement && this.medecin_paiement.id)
        },
        impressionMedecinBloquee() {
            return this.reattribution_busy || this.medecinBonModifie || (!!this.consultation_generee_id && !this.reattribution_a_jour)
        }
    },
    watch: {
        'selected_type_consultation.consult_id': 'initialiserMedecin',
        'chosen_patient.id': 'initialiserMedecin',
        is_loading(loading) {
            // La vérification du bon et du tarif doit partir en premier. La liste
            // des médecins reste indispensable, mais sera aussi revérifiée avant paiement.
            if (!loading && this.medecins_request === 0) this.initialiserMedecin()
        }
    },
    mounted() { this.initialiserMedecin() },
    beforeDestroy() {
        this.medecins_request++
        this.medecin_generation++
        this.annulerProposition(false)
    },
    methods: {
        initialiserMedecin() {
            if (this.is_loading) {
                this.medecins_loading = true
                return
            }
            this.medecin_generation++
            this.consultation_generee_id = null
            this.reattribution_busy = false
            this.reattribution_a_jour = false
            this.reattribution_message = ''
            this.annulerProposition(false)
            this.auto_attribution = null
            this.medecin_contexte = Date.now().toString(36) + '-' + Math.random().toString(36).slice(2)
            const info = this.$store.getters.medecin_bon_prepare
            const match = this.is_pre_saved_bon && info &&
                Number(info.patient_id) === Number(this.chosen_patient.id) &&
                Number(info.type_id) === Number(this.selected_type_consultation.consult_id)
            this.medecin_id = match && info.medecin_id ? Number(info.medecin_id) : null
            this.medecin_nom_initial = match ? info.medecin_nom || '' : ''
            this.medecin_paiement = null
            this.medecin_reservation_paiement = null
            this.note_medecin_rdv = ''
            this.preselection_rdv = !!this.rdv_medecin
            this.chargerMedecins()
        },
        async chargerMedecins() {
            const sequence = ++this.medecins_request
            this.medecins_error = ''
            this.medecins = []
            const typeId = this.selected_type_consultation.consult_id
            if (!this.canAttributeMedecin || !typeId || !this.chosen_patient.id) {
                this.medecins_loading = false
                return false
            }
            this.medecins_loading = true
            try {
                const response = await consultations.getMedecinsEligibles(typeId)
                if (sequence !== this.medecins_request) return false
                this.medecins = response.medecins || []
                this.auto_attribution = response.auto_attribution === true
                // RDV-010 : présélection au premier chargement réussi de la liste (« Réessayer » après un échec compris) ;
                // jamais par la vérification du paiement, qui l'abandonne (verifierMedecin), ni sur un choix déjà fait
                if (this.preselection_rdv) {
                    this.preselection_rdv = false
                    this.appliquer_preselection_rdv()
                }
                if (this.medecinInvalide) {
                    this.medecins_error = 'Le médecin choisi n’est plus éligible. Choisissez un autre médecin ou Non attribué.'
                }
                return true
            } catch (error) {
                if (sequence === this.medecins_request) {
                    this.medecins_error = 'Impossible de vérifier les médecins et le mode d’attribution. Réessayez avant de continuer.'
                }
                return false
            } finally {
                if (sequence === this.medecins_request) this.medecins_loading = false
            }
        },
        async verifierMedecin() {
            // RDV-010 : le paiement ne change jamais le médecin sans que l'utilisateur le voie (présélection abandonnée)
            this.preselection_rdv = false
            if (this.medecin_reservation) {
                const token = this.medecin_reservation
                const generation = this.medecin_generation
                try {
                    const response = await consultations.confirmerMedecin(this.reservationPayload(token))
                    if (generation !== this.medecin_generation || token !== this.medecin_reservation) return false
                    if (!response.proposition || Number(response.proposition.id) !== Number(this.medecin_id)) return false
                    this.medecin_nom_initial = response.proposition.nom
                    return true
                } catch (error) {
                    if (generation === this.medecin_generation) {
                        this.libererReservation()
                        this.medecin_id = null
                        this.medecins_error = 'La proposition doit être renouvelée. Fermez la confirmation de paiement puis relancez votre action pour choisir un médecin.'
                    }
                    return false
                }
            }
            if (!this.medecin_id) {
                if (!await this.chargerMedecins()) return false
                if (!this.auto_attribution) return true
                return this.proposerMedecin()
            }
            const id = this.medecin_id
            const loaded = await this.chargerMedecins()
            return loaded && id === this.medecin_id && !this.medecinInvalide
        },
        async avantPaiementMedecin() {
            if (this.medecin_verifying || this.consultation_payment_recorded) return false
            this.medecin_verifying = true
            try {
                if (!await this.verifierMedecin()) return false
                this.figerMedecinPaiement()
                return true
            } finally {
                this.medecin_verifying = false
            }
        },
        choisirMedecin() {
            if (this.is_printable) {
                this.reattribution_message = ''
                return
            }
            this.libererReservation()
            if (!this.medecin_id || this.medecinChoisi) this.medecins_error = ''
        },
        annulerChangementMedecin() {
            if (this.reattribution_busy) return
            this.medecin_id = this.medecin_paiement ? this.medecin_paiement.id : null
        },
        async enregistrerMedecinBon() {
            if (!this.peutReattribuerBon || !this.reattribution_a_jour || this.reattribution_busy ||
                !this.medecinBonModifie || !this.medecinChoisi || !this.medecin_id) return
            const generation = this.medecin_generation
            const consultation_id = this.consultation_generee_id
            const doctor = { id: Number(this.medecinChoisi.id), nom: this.medecinChoisi.nom }
            const expected_doctor_id = Number(this.medecin_paiement && this.medecin_paiement.id) || 0
            this.reattribution_busy = true
            this.reattribution_message = ''
            let mutation_envoyee = false
            try {
                const access = await consultations.getReattributionAccess({ doctor_id: doctor.id })
                if (generation !== this.medecin_generation) return
                if (!access || !access.success || !access.data || !access.data.access_token) throw new Error('Accès indisponible')
                mutation_envoyee = true
                const response = await consultations.reattribuerConsultation(consultation_id,
                    { doctor_id: doctor.id, expected_doctor_id }, access.data.access_token)
                if (generation !== this.medecin_generation) return
                if (!response || !response.success || Number(response.consultation_id) !== consultation_id || Number(response.doctor_id) !== doctor.id) throw new Error('Réattribution non confirmée')
                this.medecin_paiement = doctor
                this.medecin_id = doctor.id
                this.medecin_nom_initial = doctor.nom
                this.reattribution_message = 'Médecin enregistré. Le bon peut être réimprimé.'
            } catch (error) {
                if (generation !== this.medecin_generation) return
                const status = error.response && error.response.status
                this.medecin_id = this.medecin_paiement ? this.medecin_paiement.id : null
                if (mutation_envoyee) this.reattribution_a_jour = false
                this.reattribution_message = status === 409
                    ? 'La consultation a été modifiée ou démarrée. Actualisez l’attribution avant de continuer.'
                    : status === 401 && !mutation_envoyee
                        ? 'Votre session ne peut plus être authentifiée. Reconnectez-vous. Aucun changement n’a été envoyé.'
                        : 'Changement non confirmé. Actualisez l’attribution avant de réessayer.'
            } finally {
                if (generation === this.medecin_generation) this.reattribution_busy = false
            }
        },
        async actualiserMedecinBon() {
            if (!this.peutReattribuerBon || this.reattribution_busy) return
            const generation = this.medecin_generation
            const consultation_id = this.consultation_generee_id
            this.reattribution_busy = true
            this.reattribution_a_jour = false
            this.reattribution_message = ''
            try {
                const access = await consultations.getReattributionAccess({})
                if (generation !== this.medecin_generation) return
                if (!access || !access.success || !access.data || !access.data.access_token || !Array.isArray(access.data.doctors)) throw new Error('Accès indisponible')
                const response = await consultations.getConsultationsReattribuables({ consultation_id }, access.data.access_token)
                if (generation !== this.medecin_generation) return
                const row = response && Array.isArray(response.data) && response.data.find(item => Number(item.consultation_id) === consultation_id)
                if (!row) {
                    this.reattribution_message = 'Cette consultation n’est plus réattribuable (démarrée, clôturée ou indisponible). Consultez le tableau de bord.'
                    return
                }
                const doctor_id = Number(row.doctor_id) || null
                const doctor = (access.data.doctor_directory || access.data.doctors).find(item => Number(item.id) === doctor_id)
                this.medecin_paiement = doctor_id ? { id: doctor_id, nom: doctor ? doctor.nom : 'Médecin non disponible dans l’annuaire' } : null
                this.medecin_id = doctor_id
                this.medecin_nom_initial = this.medecin_paiement ? this.medecin_paiement.nom : ''
                // Refresh the eligible choices and workload without changing the confirmed attribution.
                await this.chargerMedecins()
                if (generation !== this.medecin_generation) return
                this.reattribution_a_jour = true
                this.reattribution_message = 'Attribution actualisée.'
            } catch (error) {
                if (generation === this.medecin_generation) this.reattribution_message = 'Impossible de vérifier l’attribution. Réessayez ou reconnectez-vous si votre session a expiré.'
            } finally {
                if (generation === this.medecin_generation) this.reattribution_busy = false
            }
        },
        reservationPayload(token) {
            return { reservation_token: token, patient_id: this.chosen_patient.id,
                type_consultation_id: this.selected_type_consultation.consult_id }
        },
        libererReservation() {
            const token = this.medecin_reservation
            this.medecin_reservation = null
            // Un échec de libération n'autorise aucune attribution ; le serveur applique l'expiration.
            if (token && !this.consultation_payment_recorded) return consultations.libererMedecin(token).catch(() => {})
            return Promise.resolve()
        },
        async proposerMedecin() {
            const generation = this.medecin_generation
            this.proposition_error = ''
            try {
                const response = await consultations.proposerMedecin({
                    patient_id: this.chosen_patient.id, type_consultation_id: this.selected_type_consultation.consult_id,
                    contexte: this.medecin_contexte || (this.medecin_contexte = Date.now().toString(36) + '-' + Math.random().toString(36).slice(2))
                })
                if (generation !== this.medecin_generation) {
                    if (response.reservation_token) consultations.libererMedecin(response.reservation_token).catch(() => {})
                    return false
                }
                this.proposition_medecin = response.proposition
                this.medecin_reservation = response.reservation_token
                this.proposition_visible = true
                return new Promise(resolve => { this._medecinResolve = resolve })
            } catch (error) {
                if (generation === this.medecin_generation) {
                    const payload = error && error.response && error.response.data
                    this.medecins_error = payload && payload.message ? payload.message : 'Impossible de proposer un médecin. Réessayez ou choisissez un médecin dans la liste.'
                }
                return false
            }
        },
        async ouvrirAjoutMedecin() {
            if (!this.canAttributeMedecin || this.is_printable || this.consultation_payment_recorded ||
                this.medecins_loading || this.medecins.length || this.proposition_medecin || this.ajout_medecin_busy) return
            const generation = this.medecin_generation
            const typeId = this.selected_type_consultation.consult_id
            this.ajout_medecin_visible = true
            this.proposition_visible = true
            this.ajout_medecins = []
            this.ajout_medecin_id = null
            this.ajout_medecin_error = ''
            this.ajout_medecins_loading = true
            try {
                const response = await consultations.getMedecinsSansAcces(typeId)
                if (generation !== this.medecin_generation || !this.ajout_medecin_visible) return
                if (response.aucun_habilite !== true) {
                    this.ajout_medecin_error = 'Un médecin est maintenant habilité. Revenez au bon et actualisez la liste.'
                    return
                }
                this.ajout_medecins = Array.isArray(response.medecins) ? response.medecins : []
            } catch (error) {
                if (generation === this.medecin_generation && this.ajout_medecin_visible)
                    this.ajout_medecin_error = 'Impossible de charger les profils médecins. Réessayez.'
            } finally {
                if (generation === this.medecin_generation) this.ajout_medecins_loading = false
            }
        },
        async enregistrerAccesMedecin() {
            const doctor = this.ajout_medecins.find(item => Number(item.id) === Number(this.ajout_medecin_id))
            if (!this.canAttributeMedecin || !this.ajout_medecin_visible || !doctor ||
                this.ajout_medecin_busy || this.ajout_medecins_loading || this.consultation_payment_recorded) return
            const generation = this.medecin_generation
            const typeId = this.selected_type_consultation.consult_id
            this.ajout_medecin_busy = true
            this.ajout_medecin_error = ''
            try {
                const response = await consultations.accorderAccesMedecin({ type_consultation_id: typeId, doctor_id: doctor.id })
                if (generation !== this.medecin_generation) return
                if (!response || response.success !== true || Number(response.medecin && response.medecin.id) !== Number(doctor.id))
                    throw new Error('Accès non confirmé')
                if (!await this.chargerMedecins() || generation !== this.medecin_generation) {
                    this.ajout_medecin_error = 'Accès enregistré, mais la liste n’a pas pu être vérifiée. Actualisez le bon avant de continuer.'
                    return
                }
                const eligible = this.medecins.find(item => Number(item.id) === Number(doctor.id))
                if (!eligible) {
                    this.ajout_medecin_error = 'Accès enregistré, mais le médecin n’apparaît pas encore dans la liste. Actualisez le bon.'
                    return
                }
                this.medecin_id = eligible.id
                this.medecin_nom_initial = eligible.nom
                this.medecins_error = ''
                this.ajout_medecin_visible = false
                this.proposition_visible = false
                const resolve = this._medecinResolve
                this._medecinResolve = null
                if (resolve) resolve(true)
            } catch (error) {
                if (generation !== this.medecin_generation) return
                const status = error && error.response && error.response.status
                this.ajout_medecin_error = status === 409
                    ? 'Un médecin a déjà été habilité. Revenez au bon et actualisez la liste.'
                    : status === 422
                        ? 'Ce profil ne peut pas recevoir cet accès. Choisissez un autre médecin.'
                        : 'L’accès du médecin n’a pas été confirmé. Réessayez.'
            } finally {
                if (generation === this.medecin_generation) this.ajout_medecin_busy = false
            }
        },
        async confirmerProposition() {
            if (this.proposition_busy || !this.proposition_medecin || !this.medecin_reservation) return
            this.proposition_busy = true
            const generation = this.medecin_generation
            const token = this.medecin_reservation
            try {
                const response = await consultations.confirmerMedecin(this.reservationPayload(token))
                if (generation !== this.medecin_generation || token !== this.medecin_reservation) return
                if (!response.proposition || Number(response.proposition.id) !== Number(this.proposition_medecin.id)) {
                    throw new Error('Proposition modifiée')
                }
                this.medecin_id = response.proposition.id
                this.medecin_nom_initial = response.proposition.nom
                const index = this.medecins.findIndex(item => Number(item.id) === Number(response.proposition.id))
                if (index < 0) this.medecins.push(response.proposition)
                else this.$set(this.medecins, index, response.proposition)
                this.medecins_error = ''
                this.proposition_visible = false
                const resolve = this._medecinResolve
                this._medecinResolve = null
                if (resolve) resolve(true)
            } catch (error) {
                if (generation === this.medecin_generation) this.proposition_error = 'Cette proposition n’a pas pu être confirmée. Fermez cette fenêtre et relancez votre action ; aucun enregistrement ni paiement n’a été effectué.'
            } finally {
                this.proposition_busy = false
            }
        },
        annulerProposition(focus = true) {
            this.proposition_visible = false
            this.ajout_medecin_visible = false
            this.ajout_medecin_id = null
            this.ajout_medecin_error = ''
            this.libererReservation()
            const resolve = this._medecinResolve
            this._medecinResolve = null
            if (resolve) resolve(false)
            if (focus && typeof document !== 'undefined') this.$nextTick(() => {
                const input = document.getElementById('medecin-bon')
                if (input) input.focus()
            })
        },
        // RDV-010 : médecin du rendez-vous choisi comme s'il l'était dans la liste, seulement s'il y figure (règles
        // d'attribution MED-002 inchangées) et si rien n'est encore choisi ni payé ; sinon choix normal et note
        appliquer_preselection_rdv() {
            const medecin = this.rdv_medecin
            if (!medecin || this.medecin_id || this.is_printable || this.consultation_payment_recorded) return
            const eligible = this.medecins.find(item => Number(item.id) === medecin.id)
            if (eligible) {
                this.medecin_id = eligible.id
                this.medecin_nom_initial = eligible.nom
                return
            }
            this.note_medecin_rdv = 'Médecin du rendez-vous (' + (medecin.nom || 'non renseigné') + ') non attribuable à cette spécialité : choisissez le médecin. Avec un autre médecin, marquez le rendez-vous honoré depuis l’agenda.'
        },
        figerMedecinPaiement() {
            this.medecin_paiement = this.medecinChoisi ? { id: this.medecinChoisi.id, nom: this.medecinChoisi.nom } : null
            this.medecin_reservation_paiement = this.medecin_reservation
        },
        fermerProposition() {
            if (this.proposition_visible && !this.proposition_busy && !this.ajout_medecin_busy) this.annulerProposition()
        }
    }
}
